'use client';

import React, { useMemo, useState } from 'react';
import { LayoutContext } from './LayoutContext';
import { useSearch } from '@srcDS/components/organisms/searchDropdown/useSearch';

export const LayoutProvider = ({ children, globalNodeLoading, closeAction }) => {
  const [showFormByName, setShowFormByName] = useState();
  const [showSearchDropdown, setShowSearchDropdown] = useState();
  const [showLiveChat, setShowLiveChat] = useState(true);
  const [alwaysHideLiveChat, setAlwaysHideLiveChat] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [searchResults, setSearchResults] = useState(null);

  const [isLoadingSearch, setIsLoadingSearch] = useState(false);
  const [isLoadedSearch, setIsLoadedSearch] = useState(false);
  const [isLoadedPage, setIsLoadedPage] = useState(false);

  const { gotToSearchPage, getSearchResults, isTablet, isDesktop, isLoadingSearchPage, getPositionToTop } = useSearch({
    searchValue,
    setSearchValue,
    closeAction: () => setShowSearchDropdown(false),
  });

  const onChangeSearch = async (value) => setSearchValue(value);

  const values = useMemo(() => {
    return {
      isTablet,
      isDesktop,
      showFormByName,
      setShowFormByName,
      showSearchDropdown,
      setShowSearchDropdown,
      globalNodeLoading,
      showLiveChat,
      setShowLiveChat,
      alwaysHideLiveChat,
      setAlwaysHideLiveChat,
      searchValue,
      setSearchValue,
      onChangeSearch,
      gotToSearchPage,
      getSearchResults,
      getPositionToTop,
      searchResults,
      setSearchResults,
      isLoadingSearch,
      setIsLoadingSearch,
      isLoadedSearch,
      setIsLoadedSearch,
      isLoadedPage,
      setIsLoadedPage,
      isLoadingSearchPage,
    };
  }, [
    isTablet,
    isDesktop,
    showFormByName,
    setShowFormByName,
    showSearchDropdown,
    setShowSearchDropdown,
    globalNodeLoading,
    showLiveChat,
    alwaysHideLiveChat,
    searchValue,
    setSearchValue,
    onChangeSearch,
    gotToSearchPage,
    getSearchResults,
    getPositionToTop,
    searchResults,
    setSearchResults,
    isLoadingSearch,
    setIsLoadingSearch,
    isLoadedSearch,
    setIsLoadedSearch,
    isLoadedPage,
    setIsLoadedPage,
    isLoadingSearchPage,
  ]);

  return <LayoutContext.Provider value={values}>{children}</LayoutContext.Provider>;
};
